import { CCallout } from '@coreui/react-pro'
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import DiagnosisCard from 'src/components/NewEncounter/DiagnosisCard'
import ProcedureCard from 'src/components/NewEncounter/ProcedureCard'
import { setDiagnosisCode, setProcedureCode } from 'src/redux/progressNote/progressNoteSlice'

const BillingSummaryCodeSection = ({
  section,
  title,
  pos,
  encounterType,
  visitId,
  patientId,
  isPcc,
  dateOfService,
  processStop,
}) => {
  const procedureCodesSelected = useSelector((state) => state?.progressNote?.procedureCodesSelected)
  const diagnosisCodesSelected = useSelector((state) => state?.progressNote?.diagnosisCodesSelected)

  const practice = useSelector((state) => state?.user?.practice)
  const provider = useSelector((state) => state?.user?.provider)
  const roles = useSelector((state) => state?.user?.roles) || []

  const dispatch = useDispatch()

  const setSelectedDiagnosis = (data) => {
    dispatch(setDiagnosisCode(data))
  }

  return (
    <div className="section-item">
      <div className="option-holder">
        {section?.type === 'diagnosis' ? (
          <DiagnosisCard
            setSelectedDiagnosis={setSelectedDiagnosis}
            selectedDiagnosis={diagnosisCodesSelected}
            noIndicater={true}
            isProgressNote={true}
            title={title}
            isBillSummary={true}
            patientId={patientId}
            visitId={visitId}
            isPcc={isPcc}
            dateOfService={dateOfService}
          />
        ) : section?.type === 'procedures' ? (
          <>
            {practice?.medical_coding &&
            provider?.medical_coding !== false &&
            !roles.includes('Claimocity App Biller') ? (
              <div className="card ProcedureCard empty">
                <div className="ProceduredHeaderContainer">
                  <div className="ProcedureCardHeader">
                    <h5 className="card-title ProcedureCardTitle">Procedure Codes</h5>
                  </div>
                </div>
                <div className="Procedure-card-select-card">
                  <CCallout color="warning">
                    <p>This visit will be submitted to the coding team</p>
                  </CCallout>
                </div>
              </div>
            ) : (
              <ProcedureCard
                setSelectedProcedure={(data) => dispatch(setProcedureCode(data))}
                selectedProcedure={procedureCodesSelected}
                noEncounter={true}
                noIndicater={true}
                isProgressNote={true}
                title={title}
                pos={pos}
                initialBtn={encounterType}
                dateOfService={dateOfService}
                processStop={processStop}
              />
            )}
          </>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  )
}

export default BillingSummaryCodeSection
